/*Email validations*/

function sendRequest(value) {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
    emailPattern.test(value);
    return new Promise((resolve) => {
        setTimeout(function () {
            if (emailPattern.test(value)) {
                resolve(true);
            } else {
                resolve(false);
            }
        }, 500);
    });
}

function asyncValidation(params) {
    return sendRequest(params.value);
}

/*Phone number validation*/

function sendRequestPhone(value) {
    const initNumber = value.substr(0, 2)
    const numberPattern = /^[0-9]{9,10}$/;
    numberPattern.test(value);
    return new Promise((resolve) => {
        setTimeout(function () {
            if (numberPattern.test(value) && (initNumber === '09' || initNumber === '02' || initNumber === '03'
                || initNumber === '04' || initNumber === '05' || initNumber === '06' || initNumber === '07')) {
                resolve(true);
            } else {
                resolve(false);
            }
        }, 300);
    });
}

function asyncPhoneValidation(params) {
    return sendRequestPhone(params.value);
}


export {asyncValidation, asyncPhoneValidation}